<lib-footer
  class="footer"
  [variant]="variant"
  [date]="now()"
  [status]="connectionStatus"
  [isConnectedFlag]="isConnected"
  [customCopyright]="'LAYOUT.FOOTER_COPYRIGHT' | translate"
  [tenantName]="getDisplayTenant()"
  [displayTenant]="displayTenant && showTenant()"
></lib-footer>
